import { PoweredByAiFi } from "src/assets/icons/PoweredByAiFi";

interface PoweredByAiFiBlockProps {
  href?: string;
}

export const PoweredByAiFiBlock = ({ href = "https://www.aifi.com" }: PoweredByAiFiBlockProps) => {
  const content = <PoweredByAiFi />;

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      ) : (
        content
      )}
    </div>
  );
};
